import { Injectable } from '@angular/core';
import { Title, Meta, MetaDefinition } from '@angular/platform-browser';

@Injectable()
export class StyxHeadService {
    protected titleService: Title;
    protected metaService: Meta;

    private _primaryTitle = ' - Worktile';
    private _title = '';
    private _unread = 0;
    private _theme = '';

    constructor(titleService: Title, metaService: Meta) {
        this.titleService = titleService;
        this.metaService = metaService;
    }

    private _getDOM(selector: string) {
        return document.querySelector(selector);
    }

    public setTitle(title: string): void {
        this._title = title;
        let newTitle = `${this._title}${this._primaryTitle}`;
        if (this._unread > 0) {
            newTitle = `(${this._unread}) ` + newTitle;
        }
        this.titleService.setTitle(newTitle);
    }

    public setFullTitle(newTitle: string): void {
        this.titleService.setTitle(newTitle);
    }

    public setUnReadTitle(unread: number) {
        this._unread = unread;
        if (unread && unread > 0) {
            this.setTitle(this._title);
            this.updateLink('#icon', `/image/favicon/${this._theme}-unread.ico`);
        } else {
            this.setTitle(this._title);
            this.updateLink('#icon', `/image/favicon/${this._theme}.ico`);
        }
    }

    public getTitle(): string {
        return this.titleService.getTitle();
    }

    public addTag(tag: MetaDefinition, forceCreation?: boolean): HTMLMetaElement | null {
        return this.metaService.addTag(tag, forceCreation);
    }

    public addTags(tags: MetaDefinition[], forceCreation?: boolean): HTMLMetaElement[] {
        return this.metaService.addTags(tags, forceCreation);
    }

    public updateTag(tag: MetaDefinition, selector?: string): HTMLMetaElement | null {
        return this.metaService.updateTag(tag, selector);
    }

    public removeTag(attrSelector: string): void {
        this.metaService.removeTag(attrSelector);
    }

    public updateLink(selector: string, href: string): void {
        const origin = (window as any).location.origin;
        const link = this._getDOM(selector) as HTMLLinkElement;
        if (link) {
            link.href = origin + href;
        }
    }

    // public setTheme(theme: string): void {
    //     this._theme = theme;
    //     this.updateLink('#theme', `/styles/${this._theme}${WT_ENV.isProduction ? '.min' : ''}.css`);
    //     this.updateLink('#icon', `/image/favicon/${this._theme}${this._unread ? '-unread' : ''}.ico`);
    // }
}
